"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACTIVITY_DIRECTION_FILTERS = exports.ACTIVITY_TYPE_FILTERS = exports.DEFAULT_ACTIVITY_FILTERS = void 0;
exports.isActivityTypeFilter = isActivityTypeFilter;
exports.activityFilterDateBounds = activityFilterDateBounds;
exports.matchesActivityFilters = matchesActivityFilters;
exports.hasActiveActivityFilters = hasActiveActivityFilters;
exports.scanFilteredActivityPage = scanFilteredActivityPage;
const activity_view_1 = require("./activity-view");
exports.DEFAULT_ACTIVITY_FILTERS = {
    activityType: 'all',
    direction: 'all',
    from: '',
    to: '',
    leadEntityId: '',
};
exports.ACTIVITY_TYPE_FILTERS = new Set([
    'all',
    'phone',
    'whatsapp',
    'stage',
    'lead',
]);
exports.ACTIVITY_DIRECTION_FILTERS = new Set([
    'all',
    'inbound',
    'outbound',
]);
const EVENT_TYPES = {
    phone: new Set(['crm.phone_call']),
    whatsapp: new Set(['crm.whatsapp_message', 'crm.whatsapp_activity', 'whatsapp_activity']),
    stage: new Set(['crm.stage_changed', 'stage_changed']),
    lead: new Set(['crm.lead_created', 'lead_created']),
};
function isActivityTypeFilter(value) {
    return typeof value === 'string' && exports.ACTIVITY_TYPE_FILTERS.has(value);
}
function activityFilterDateBounds(filters) {
    return {
        from: filters.from ? new Date(`${filters.from}T00:00:00`) : undefined,
        to: filters.to ? new Date(`${filters.to}T23:59:59.999`) : undefined,
    };
}
function matchesActivityFilters(event, filters) {
    if (filters.activityType !== 'all' && !EVENT_TYPES[filters.activityType].has(event.type))
        return false;
    if (filters.direction !== 'all' && event.safeMetadata.direction !== filters.direction)
        return false;
    if (filters.leadEntityId && event.entity.id !== filters.leadEntityId)
        return false;
    const bounds = activityFilterDateBounds(filters);
    const occurredAt = (0, activity_view_1.activityEventDate)(event.occurredAt);
    if (bounds.from && occurredAt < bounds.from)
        return false;
    if (bounds.to && occurredAt > bounds.to)
        return false;
    return true;
}
function hasActiveActivityFilters(filters) {
    return filters.activityType !== 'all'
        || filters.direction !== 'all'
        || Boolean(filters.from || filters.to || filters.leadEntityId);
}
async function scanFilteredActivityPage({ cursor, filters, pageSize, maxScanned, loadBatch, }) {
    const items = [];
    let lastCursor = cursor;
    let hasMore = true;
    let scanned = 0;
    while (items.length < pageSize && scanned < maxScanned && hasMore) {
        const batchLimit = Math.min(pageSize - items.length, maxScanned - scanned);
        const batch = await loadBatch(lastCursor, batchLimit);
        const batchScanned = batch.scanned ?? batch.items.length;
        if (batchScanned === 0) {
            hasMore = false;
            break;
        }
        scanned += batchScanned;
        lastCursor = batch.lastCursor;
        hasMore = batch.hasMore;
        items.push(...batch.items.filter((event) => matchesActivityFilters(event, filters)));
    }
    return { items, lastCursor, hasMore };
}
